module.exports = __webpack_public_path__ + "img/loudian2.d8c0d58f.svg";